// extracted by mini-css-extract-plugin
export default {"inputContainerUnique":"ArquivamentoSolic_inputContainerUnique__50ibn","descricao":"ArquivamentoSolic_descricao__ag6Sj","divPrincipal":"ArquivamentoSolic_divPrincipal__vMjQZ"};